import { Button, Col, Row } from 'react-bootstrap';
import { AlertTriangle } from 'react-feather';
import styles from '../activate-account/activate-account.module.scss';

type InvalidPasswordLinkProps = {
  fromInvite: boolean;
  redirectUri: string | null;
};

export function InvalidPasswordLink({
  fromInvite,
  redirectUri,
}: InvalidPasswordLinkProps) {
  return (
    <>
      <Row>
        <Col>
          <p className={'header'}>We can't set your password</p>
          <p className={'subtext'}>This link is invalid or has expired.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            className={styles['error-panel']}
            role={'alert'}
            data-testid={'invalid-password-link'}
          >
            <div className={styles['error-icon']} aria-hidden={'true'}>
              <AlertTriangle size={16} strokeWidth={2} />
            </div>
            <div className={styles['error-text']}>
              {fromInvite
                ? 'Ask your administrator to resend your invite.'
                : "Sign in and choose 'Forgot password?' to get a new link."}
            </div>
          </div>
        </Col>
      </Row>
      {!fromInvite && redirectUri && (
        <Row className={'form-button-row'}>
          <Col>
            <Button
              href={redirectUri}
              color="primary"
              style={{ width: '100%' }}
            >
              Back to sign in
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
}

export default InvalidPasswordLink;
